import Evaluation from "./KrEvaluation.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrEvaluation = install(Evaluation); // 生成带有 install 方法的组件

export default KrEvaluation;
